import axios from '../../axios/axios-db';
import { FETCH_PATIENTS_START, FETCH_PATIENTS_SUCCESS } from './actionTypes';

export function fetchPatients() {
  return async (dispatch) => {
    dispatch(fetchPatientsStart());
    const response = await axios.get(
      'https://react-cvad.firebaseio.com/pacients.json'
    );

    const patients = [];
    for (let key in response.data) {
      patients.push(response.data[key][0]);
    }
    dispatch(fetchPatientsSuccess(patients));
  };
}

export function fetchPatientsStart() {
  return {
    type: FETCH_PATIENTS_START,
  };
}
export function fetchPatientsSuccess(patients) {
  return {
    type: FETCH_PATIENTS_SUCCESS,
    patients,
  };
}
